export class Gtm {
    _getDataLayer() {
        if (this._dataLayer === undefined) {
            window.dataLayer = window.dataLayer || [];
            this._dataLayer = window.dataLayer;
        }
        return this._dataLayer;
    }
    _pushEvent(eventData) {
        if (this.enabled) {
            this._getDataLayer().push(eventData);
        }
    }
    _getUserId() {
        return this._appController.sdk.authManager.authResponse === null
            ? "guest" : this._appController.sdk.authManager.authResponse.userId;
    }
    constructor(appController) {
        this.enabled = true;
        this._xrSessionStartTime = undefined;
        this._tokenPrice = 0.11;
        this._appController = appController;
    }
    xrSessionStarted() {
        this._xrSessionStartTime = new Date().getTime();
    }
    xrSessionStopped() {
        if (this._xrSessionStartTime === undefined)
            return;
        const startTime = this._xrSessionStartTime;
        this._xrSessionStartTime = undefined;
        const endTime = new Date().getTime();
        if (endTime < startTime)
            return;
        const durationInSeconds = (endTime - startTime) / 1000.0;
        const xrSessionSecondsEventData = {
            event: "xr_session_duration",
            value: durationInSeconds,
            userId: this._getUserId(),
            xrMode: "true"
        };
        this._pushEvent(xrSessionSecondsEventData);
    }
    // I have no idead of the though process behind this function. It was explicitly written as such in the task.
    _generateTransactionId(n) {
        const add = 1;
        let max = 12 - add;
        if (n > max) {
            return `${this._generateTransactionId(max) + this._generateTransactionId(n - max)}`;
        }
        max = Math.pow(10, n + add);
        const min = max / 10;
        const number = Math.floor(Math.random() * (max - min + 1)) + min;
        return `${number}`.substring(add);
    }
    transaction(value, type) {
        const transaction = {
            event: "purchase",
            ecommerce: {
                event_category: "ecommerce",
                transaction_id: `T_${this._generateTransactionId(5)}`,
                affiliation: "Dreamcam",
                userId: this._getUserId(),
                xrMode: "true",
                value: value * this._tokenPrice,
                transactionType: type,
                tax: 0,
                shipping: 0,
                currency: "USD",
                coupon: "",
                items: [
                    {
                        item_id: `T_${this._generateTransactionId(6)}`,
                        item_name: type,
                        affiliation: "Dreamcam",
                        coupon: "",
                        currency: "USD",
                        discount: 0,
                        index: 1,
                        item_brand: "",
                        item_category: "",
                        item_category2: "",
                        item_category3: "",
                        item_category4: "",
                        item_category5: "",
                        item_list_id: "",
                        item_list_name: "",
                        item_variant: "",
                        location_id: "",
                        price: value * this._tokenPrice,
                        promotion_id: "",
                        promotion_name: "",
                        quantity: 1,
                    }
                ]
            }
        };
        this._pushEvent(transaction);
    }
    tipsSent(value) {
        this.transaction(value, "tipsSent");
    }
    onPrivateShowCompleted(value) {
        this.transaction(value, "onPrivateShowCompleted");
    }
    toysMenuItemPurchased(value) {
        this.transaction(value, "toysMenuItemPurchased");
    }
    tipMenuItemPurchased(value) {
        this.transaction(value, "tipMenuItemPurchased");
    }
    complimentSent(value) {
        this.transaction(value, "complimentSent");
    }
}
